import { LoadDropdownDataService } from './../../shared/common-components/load-dropdown-data/load-dropdown-data.service';
import { CommonGetDropdownModel, DropdownSections } from './../../shared/common-components/load-dropdown-data/load-dropdown-data.model';
import { LoginService } from "./login.service";
import { AfterViewInit, Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { ChangePasswordModel, ForgetPasswordModel, LoginModel, ResetPasswordModel, Verification, VerifyOtpModel, View } from "./login.model";
import { ToastrService } from "ngx-toastr";
import { StorageService } from "src/app/shared/services/storage.service";
import { throwError } from "rxjs";
import { ResponseModel } from "src/app/shared/models/response-model.model";
import { CommonService } from "src/app/shared/services/common.service";
import { PermissionService } from "src/app/shared/services/permission.service";
import { HttpStatusCode } from "@angular/common/http";
import { MULTIPLEORG_ACCESSTOKEN, REMAIMBER_USERS,Roles, SESSION_EXPIRE_TIME, USER_ORGANIZATIONS, INTERGRATED_APPS } from 'src/app/shared/enum/common-enum';
import { TranslateService } from '@ngx-translate/core';
import { RealtimeService } from 'src/app/shared/services/realtime.service';
import { DatePipe } from '@angular/common';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationLanguages, AUTHORIZED_TOKEN, NAVIGATE_ALLTABS_LOGIN, REFRESH_TOKEN, SELECTED_LANGUAGE, TOKEN_EXPIRATION_MS, USER_ACCOUNT_DETAILS } from '../../shared/enum/common-enum';
import { TabCommunicationService } from '../../shared/services/tab-communication.service';
import { PushNotificationService } from '../../shared/services/push-notification.service';

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    providers:[DatePipe]
})
export class LoginComponent extends CommonService implements OnInit ,AfterViewInit {
    @ViewChild("LoginForm") LoginForm!: NgForm;
    @ViewChild("ForgetPasswordForm") ForgetPasswordForm!: NgForm;
    @ViewChild("ResetPasswordForm") ResetPasswordForm!: NgForm;

    // public user: firebase.User;
    loginModel = new LoginModel();
    forgetPasswordModel = new ForgetPasswordModel();
    verifyOtpModel = new VerifyOtpModel();
    resetPasswordModel = new ResetPasswordModel();
    public show: boolean = false;
    public show1: boolean = false;
    public show2: boolean = false;
    public isUserFirstLogin: boolean = false;
    public errorMessage: any;
    userRoles = Roles;

    pageView : number = View.Login;
    isOtpInputVisible:boolean=false;
    otpInput1:number;
    otpInput2:number;
    otpInput3:number;
    otpInput4:number;
    otpInput5:number;
    otpInput6:number;
    reEnterPassword:string;
    emailPattern:any="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";
    passwordPattern: string = "^(?=.*[abcdefgijkmnopqrstwxyz])(?=.*[ABCDEFGHJKLMNPQRSTWXYZ])(?=.*[0123456789])(?=.*[*@$-+?_&=!%{} /]).{12,}$";
    timerValue = 300; // Set initial timer value to 300 seconds;
    private otpInterval: any;
    remember_me_tooltip_text ='Selecting this option will store this device’s IP address and allow it to skip two-factor authentication for 30 days. Only select this on trusted devices. Never select this option on public devices.'
    nextValue = '';
    view = View;

    changePasswordModel = new ChangePasswordModel();
    verification = new Verification();
    userDetails: any;
    isForgotPasswordCall: boolean;

    commonGetDropdownModel = new CommonGetDropdownModel();
    dropdownIds = [
        { Dsi: DropdownSections.DialCodes },
    ];
    public loggedUserStoreDetails = {email:"",rememberMe:false ,trustToken:""};
    public userEmail;
    public rememberMeUsers = [];

    //processing
    loggingIn: boolean = false;
    isVerifying: boolean = false;
    activeSessionToastMessage  = {
        english : 'A session already exists. You have been switched over to the active session.',
        spanish : 'Ya existe una sesión. Has sido redirigido a la sesión activa.'
    }

    constructor(
        public router: Router,
        private loginService: LoginService,
        private toaster1: ToastrService,
        public storageservice: StorageService,
        public renderer: Renderer2,
        public permissionService : PermissionService,
        public loadDropdownDataService:LoadDropdownDataService,
        private translate: TranslateService,
        public realtimeService:RealtimeService,
        private datePipe: DatePipe,
        private offcanvasService: NgbOffcanvas,
        private translateService : TranslateService,
        private pushNotificationService : PushNotificationService
    ) {
     super(renderer); 
      this.clearAndstoreRememberMeUsers();
    }

    clearAndstoreRememberMeUsers(){
        this.rememberMeUsers = (this.storageservice?.retrieve(REMAIMBER_USERS))??[];
       const tabs = (this.storageservice?.retrieve(REMAIMBER_USERS))??[];
        this.storageservice.clear();
        this.storageservice.store(REMAIMBER_USERS ,this.rememberMeUsers ??[]);
    }
    
    ngOnInit() {
        this.toaster1?.clear()
        history.pushState(null, '', location?.href);
    }

    ngAfterViewInit() {
        setTimeout(() => {
        this.realtimeService?.disposeCieloHubConnection()

          const usernameField = document.getElementById('login_email') as HTMLInputElement;
          const passwordField = document.getElementById('login_password') as HTMLInputElement;
          
          if (usernameField && passwordField) {
            usernameField.value = '';
            passwordField.value = '';
            this.loginModel = new LoginModel();
          }
        }, 1000);

       if(this.offcanvasService?.hasOpenOffcanvas()) this.offcanvasService?.dismiss('close');
      }

      onChangeEmail(){
       if(!this.rememberMeUsers?.length || this.LoginForm.form.controls.login_email.invalid) return;
        const user = this.rememberMeUsers?.find((x)=> x?.email == this.loginModel?.email);
        this.loginModel.rememberMe = user ? true : false;
        this.loginModel.trustToken = user ? user?.trustToken : "";
      }

    fillDropdownData(dropDownData){
        this.loadDropdownDataService.commonGetDropdownModel.dialCodes = dropDownData?.dialCodes??[];
    }

    // Simple Login
    async login() {
        // this.pageView = this.view.Verification
        if (this.LoginForm.valid) {
            this.loggingIn = true;
            const token = this.storageservice.retrieve(AUTHORIZED_TOKEN)
            if(token){
                this.router.navigate(["/dashboard"]);
                const lang =  this.storageservice.retrieve(SELECTED_LANGUAGE);
                this.toaster1.success(lang == ApplicationLanguages.English ? this.activeSessionToastMessage.english : this.activeSessionToastMessage.spanish);
                return;
            }
            await this.pushNotificationService.getTokenForSubscription();
            this.loginService
                .SignIn(this.loginModel)
                .subscribe({
                    next:(res: ResponseModel) => {
                        if (res.isSucceeded) {
                            this.storageservice.store(
                                AUTHORIZED_TOKEN,
                                res?.response?.tokens?.accessToken
                            );
                            this.userDetails = res?.response?.user;
    
                            if(res?.response?.twoFactorCode){
                                this.pageView = View.Verification;
                                this?.cancelOTPTimer()
                                this.startOTPTimer();
                                this.verification.twoFactorToken = res?.response?.twoFactorCode;
                                this.toaster1.success(res?.message);
                            }
    
                            else if(res?.response?.user == undefined){
                                this.pageView = View.CreateNewPassword;
                                this.isForgotPasswordCall = false;
                                this.changePasswordModel.phoneCodeId = res?.response?.user?.phoneCodeId;
                                this.changePasswordModel.contactNumber = res?.response?.user?.contactNumber;
                            }
                            else{
                               this.storeLoginResponceDetails(res);
                            }
                        } else {
                            this.loggingIn = false;
                            if(res.message != undefined){
                                this.toaster1.error(res.message, null, { timeOut: 1200 });
                            }
                            if(res?.errors?.length > 0){
                                this.toaster1.error(res.errors[0], null, { timeOut: 1200 });
                            }
                        }
                    } ,error:(err)=>{
                        this.loggingIn = false;
                    }
                });
        }
        else{
            this.toaster1.error("Username or password is incorrect", null, { timeOut: 1200 });
        }
    } 


    clearOtpsInputs(){
        [1, 2, 3, 4, 5, 6]?.forEach(i => this[`otpInput${i}`] = undefined);
    }

    async  storeLoginResponceDetails(res , fromTwoFactorVerification = false){
            this.userDetails = res?.response?.user;
            this.storageservice.store(REFRESH_TOKEN,res?.response?.tokens?.refreshToken);
            this.storageservice.store(USER_ACCOUNT_DETAILS,res?.response?.user);
            this.storageservice.store(INTERGRATED_APPS,res?.response?.integratedApps);
            this.storageservice.isProfileComplete = this.userDetails?.isProfileComplete;
            this.storageservice.store(this.userDetails.id,this.storageservice?.isProfileComplete);
            this.storageservice.store(SELECTED_LANGUAGE,res.response?.user?.settings?.language);
            const currentDateAndtime = new Date();
            const tokenExpireTime = currentDateAndtime?.getTime() + TOKEN_EXPIRATION_MS;
            this.storageservice?.store(SESSION_EXPIRE_TIME, tokenExpireTime);
            this.translate.setDefaultLang(res.response?.user?.settings?.langCode);
            if (!fromTwoFactorVerification && !this.loginModel.rememberMe) {
                this.rememberMeUsers = this.rememberMeUsers.filter((user) => user?.email !== this.loginModel.email);
                this.storageservice.store(REMAIMBER_USERS, this.rememberMeUsers);
            }

            if(res.response?.user?.organizations?.length > 1){
                this.storageservice.store(MULTIPLEORG_ACCESSTOKEN, res?.response?.tokens?.accessToken);
                this.storageservice.store(USER_ORGANIZATIONS,res?.response?.user?.organizations);
                this.router.navigate(["/auth/select-organization"]);
            }
            else{

                await  this.realtimeService?.createHubConnectionForCielo();
                this.router.navigate(["/dashboard"]); 
            }
            this.loggingIn = false;
            this.isVerifying = false;
    }

    private handleError(error: any) {
        if (error.status === HttpStatusCode.Forbidden) {
        } else {
          throwError(error.error.message);
        }
    
        return throwError(error);
      }
   
    reSendOtpOnEmail(){
        this.timerValue = 300; 
        this.clearOtpsInputs();
        this.sendOtp();
    }

    sendOtpOnEmail(){
        if(this.ForgetPasswordForm.valid){
        this.sendOtp()
    }
}

    sendOtp(){
        this.loginService.sendOtpOnEmail(this.forgetPasswordModel)
            
        .subscribe((res: ResponseModel) => {
            if (res.isSucceeded) {
                this.cancelOTPTimer()
                this.startOTPTimer();
                this.isOtpInputVisible = true;
                this.verifyOtpModel.email = this.forgetPasswordModel.email;
                this.toaster1.success(res.message);
            } else {
                if(res.message != undefined){
                    this.toaster1.error(res.message);
                }
                if(res?.errors?.length > 0){
                    this.toaster1.error(res.errors[0]);
                }
            }
        });
    }

    verifyOtp(){
        if(this.ForgetPasswordForm.valid){
            this.verifyOtpModel.otp = `${this.otpInput1}${this.otpInput2}${this.otpInput3}${this.otpInput4}${this.otpInput5}${this.otpInput6}`;
            this.loginService.verifyOTP(this.verifyOtpModel)
            
            .subscribe((res: ResponseModel) => {
                if (res.isSucceeded) {
                    this.pageView = 3;
                    this.resetPasswordModel.email = this.verifyOtpModel.email;
                    this.resetPasswordModel.resetPasswordToken = res.response.resetPasswordToken;
                    this.toaster1.success(res.message);
                    this.otpInput1=null;
                    this.otpInput2=null;
                    this.otpInput3=null;
                    this.otpInput4=null;
                    this.reEnterPassword = null;
                } else {
                    if(res.message != undefined){
                        this.toaster1.error(res.message);
                    }
                    if(res?.errors?.length > 0){
                        this.toaster1.error(res.errors[0]);
                    }
                }
            });
        }
    }

    resetPassword(){
        if(this.ResetPasswordForm.valid){
            if(this.reEnterPassword == this.resetPasswordModel.newPassword){
                this.loginService.resetPassword(this.resetPasswordModel)
                
                .subscribe((res: ResponseModel) => {
                    if (res.isSucceeded) {
                        this.toaster1.success(res.message);
                        this.pageView = View.Login;
                        this.resetPasswordModel.newPassword = '';
                        this.forgetPasswordModel.email = '';
                        this.loginModel = new LoginModel();
                        this.clearOtpsInputs();
                    } else {
                        if(res.message != undefined){
                            this.toaster1.error(res.message);
                        }
                        if(res?.errors?.length > 0){
                            this.toaster1.error(res.errors[0]);
                        }
                    }
                });
                this.loggingIn = false;
            }
            else{
                this.toaster1.error("Password must match", null, { timeOut: 2000 });
            }
        }
    }

    changePassWord(){
        this.changePasswordModel.currentPassword = this.loginModel.password;
        this.changePasswordModel.newPassword = this.resetPasswordModel.newPassword;
        this.changePasswordModel.isSmsAllowed;
        if(this.ResetPasswordForm.valid){
            if(this.reEnterPassword == this.resetPasswordModel.newPassword){
                this.loginService.changePassword(this.changePasswordModel)
                
                .subscribe((res: ResponseModel) => {
                    if (res.isSucceeded) {
                        this.toaster1.success(res.message);
                        this.pageView = View.Login;
                        this.loginModel = new LoginModel();
                        this.clearOtpsInputs();
                        this.clearAndstoreRememberMeUsers();
                    } else {
                        if(res.message != undefined){
                            this.toaster1.error(res.message);
                        }
                        if(res?.errors?.length > 0){
                            this.toaster1.error(res.errors[0]);
                        }
                    }
                });
            }
            else{
                this.toaster1.error("New password and Re-enter password must match", null, { timeOut: 2000 });
            }
            this.loggingIn = false;
        }
        else{
            this.toaster1.error("Passwords must be minimum of 12 characters and include uppercase (A-Z), lower case (a-z), numbers (0-9) and special characters (such as !@#$%^&*).", null, { timeOut: 2000 });
        }
    }
    
  //#region for an otp

//   startOTPTimer() {
//     this.otpInterval = setInterval(() => {
//       if (this.timerValue > 0) {
//         this.timerValue--; // Decrease timer value
//         if (this.timerValue == 0) {
//           clearInterval(this.otpInterval);
//         }
//       }
//     }, 1000);
//   }

otpStartTime: number | null = null;
startOTPTimer() {
    this.otpStartTime = Date.now(); // Store the start time
  
    this.otpInterval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - (this.otpStartTime || 0)) / 1000);
      this.timerValue = Math.max(300 - elapsedSeconds, 0); // Calculate remaining time
  
      if (this.timerValue === 0) {
        clearInterval(this.otpInterval);
      }
    }, 1000);
  }
  

  cancelOTPTimer() {
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
      this.otpInterval = null;
    }
    this.timerValue = 300; 
}
    //#endregion

     onKeyUp(event, previousElement, nextElement) {
    if (event.type === 'keyup') {
        if (event.target.value !== '') {
            document.getElementById(nextElement).focus();
            this.focus(document.getElementById(nextElement));
            if (event.key === 'ArrowLeft') {
                document.getElementById(previousElement).focus();
                this.focus(document.getElementById(previousElement));
            } else if (event.key === 'ArrowRight') {
                document.getElementById(nextElement).focus();
                this.focus(document.getElementById(nextElement));
            }
        }

        if (event.key === 'Backspace') {
            if(this.nextValue){
                document.getElementById(event?.target?.id)?.focus();
                this.focus(document.getElementById(event?.target?.id));
            } else {
                document.getElementById(previousElement)?.focus();
                this.focus(document.getElementById(previousElement));
            }
        }
    }
}

focus(e){
    this.nextValue = e?.value;
    e?.select();
}

    clearValues(){
        this.isOtpInputVisible = false;
        this.loginModel = new LoginModel();
        this.forgetPasswordModel = new ForgetPasswordModel();
        this.verifyOtpModel = new VerifyOtpModel();
        this.resetPasswordModel = new ResetPasswordModel();
        this.cancelOTPTimer();
        this.clearOtpsInputs();
    }

    showPassword() {
        this.show = !this.show;
    }
    showPassword1() {
        this.show1 = !this.show1;
    }
    showPassword2() {
        this.show2 = !this.show2;
    }

    onForgotPasswordClick(){
        this.pageView = 2;
        this.isForgotPasswordCall = true;
        this.isOtpInputVisible = false;
    }

    //2fa verification 

    verifyTwoFactorAuth(verificationForm){
        if(verificationForm.valid){
          this.isVerifying = true;
          this.verification.otpToken = `${this.otpInput1}${this.otpInput2}${this.otpInput3}${this.otpInput4}${this.otpInput5}${this.otpInput6}`;
          this.verification.email = this.loginModel.email;
       this.loginService.twoFactorVerification(this.verification).subscribe({
        next:(res)=>{
            if(res?.isSucceeded){
                this.storageservice.store(AUTHORIZED_TOKEN,res?.response?.tokens?.accessToken);
                this.storeLoginResponceDetails(res);
                if(res?.response?.trustToken){
                    const rememberMeUser = {
                        trustToken : res?.response?.trustToken,
                        email : res?.response?.user.email,
                    }
                    this.rememberMeUsers  = this.rememberMeUsers?.filter((x)=> x?.email != this.loginModel?.email);
                    this.rememberMeUsers?.push(rememberMeUser)
                    this.storageservice.store(REMAIMBER_USERS , this.rememberMeUsers??[]);
                } ;
                this.verification = new Verification();
            }else{
                this.isVerifying = false;
                this.toaster1.error(res?.message);
            }
        },error(err) {
            this.isVerifying = false;
            this.toaster1.error(err?.errors[0])
        },
       })
    }
}


reSendOtpForVerification(){
   this.timerValue = 300; 
   this.clearOtpsInputs();
   this.loginService.resendOtpTwoFactorVerification(this.loginModel.email).subscribe({
    next:(res)=>{
        if(res?.isSucceeded){
            this.toaster1?.success(res?.message);
        }else{
            this.toaster1?.error(res?.message)
        }
        this?.cancelOTPTimer()
        this.startOTPTimer();
    },error:(err)=>{
        this.toaster1?.error(err?.errors[0])
    }
   })
}

onPaste(event: ClipboardEvent){
    const pastedData = event?.clipboardData?.getData('text') || '';
    if (!/^\d+\s*$/.test(pastedData)) {
        event?.preventDefault();  // Block the paste if it contains non-numeric characters
        return;
    }
    const otps = pastedData?.split('')??[];
    if(otps?.length > 1){
        [1, 2, 3, 4, 5, 6]?.forEach(i => this[`otpInput${i}`] = undefined);
        otps?.forEach((value,i) => this[`otpInput${i+1}`] = value);
    } 
}

    getFormattedTime() {
        const seconds = this.timerValue * 1000; // Convert to milliseconds
        return this.datePipe.transform(seconds, 'mm:ss'); // Format as MM:SS
      }
}